/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_nav_user_language = /** @type {(inputs: {}) => string} */ () => {
	return `Idioma`
};

const en_nav_user_language = /** @type {(inputs: {}) => string} */ () => {
	return `Language`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const nav_user_language = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nav_user_language(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("nav_user_language", locale)
	if (locale === "es") return es_nav_user_language(inputs)
	return en_nav_user_language(inputs)
};
export { nav_user_language as "nav_user.language" }